

import { parallax } from './modules/parallax.js';
import { front } from './modules/front.js';


document.addEventListener('DOMContentLoaded', () => {
  parallax();
  front();
});         